<template>
    <div class="max-w-4xl w-full ">
        <div class="text-black font-semibold text-lg mb-5">Notizen</div>
        <div class="flex flex-row justify-between items-start mb-5">
            <div
                class="rounded-md mr-3 text-center py-1 w-18 text-white font-semibold bg-primary-light "
            >
                {{ isPdf ? watchTime : computedTime }}
            </div>
            <input-textarea
                :id="'note'"
                :label="'Notiz'"
                :name="'note'"
                v-model="state.note"
                :labelClass="'bg-white'"
                class="w-full"
                :heightClass="'h-28'"
            />
        </div>
        <div class="flex flex-row justify-end items-center mb-8">
            <custom-button
                v-if="state.selectedNote"
                @click="
                    state.selectedNote = null;
                    state.note = '';
                "
                class="w-36 h-11 "
                :text="'Abbrechen'"
                :bgColor="'bg-transparent'"
                :textColor="'text-black'"
                :id="'cancel-button'"
            /><custom-button
                @click="state.selectedNote ? UPDATE_NOTE() : CREATE_NOTE()"
                class="w-36 h-11 ml-2 "
                :text="state.selectedNote ? 'Bearbeiten' : 'Hinzufügen'"
                :bgColor="'bg-primary'"
                :textColor="'text-white'"
                :id="'add-note-button'"
            />
        </div>
        <input-select
            v-if="GET_NOTES.length > 0"
            :activeColor="'grey'"
            :label="''"
            :labelClass="'bg-transparent'"
            :id="'filter-notes'"
            :name="'filter-notes'"
            class="w-80 max-w-full mb-12"
            ref="dropdown"
            :activeItems="[state.selectedFilter]"
            :nameColumn="'name'"
            :options="state.allFilters"
            :defaultColor="'grey-light'"
            :background="'bg-white'"
            @change-item="
                (option) => {
                    state.selectedFilter = option;
                    $refs.dropdown.close();
                }
            "
        />
        <note
            v-for="note in filterdNotes"
            :key="note.id"
            :note="note"
            :isPdf="isPdf"
            @edit="editNote(note)"
            @delete="DELETE_NOTE(note)"
            @time-click="$emit('changeTime', note.seconds)"
        />
    </div>
</template>

<script>
import {
    computed,
    defineComponent,
    onMounted,
    reactive,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import {
    cloneData,
    compareNumbers,
    getData,
} from "../../../../common/dataHelper";
import { dateToTimestamp } from "../../../../common/formatDates";
import CustomButton from "../../../../components/input/CustomButton.vue";
import InputSelect from "../../../../components/input/InputSelect.vue";
import InputTextarea from "../../../../components/input/InputTextarea.vue";
import {
    HELPER_TYPES,
    NOTE_TYPES,
    SLIDE_TYPES,
    STORE_TYPES,
} from "../../../../store/types";
import Note from "./Note.vue";
export default defineComponent({
    components: { InputTextarea, CustomButton, Note, InputSelect },
    name: "Notes",
    props: {
        watchTime: { type: [Number, String], required: true },
        isPdf: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["changeTime"],
    setup(props) {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({
            note: "",
            selectedNote: null,
            selectedFilter: null, //get set in mounted
            allFilters: [
                {
                    id: 1,
                    name: props.isPdf
                        ? "Seitenzahl aufsteigend"
                        : "Zeit aufsteigend",
                    shortName: "time desc", //absteigend
                },
                {
                    id: 2,
                    name: props.isPdf
                        ? "Seitenzahl absteigend"
                        : "Zeit absteigend",
                    shortName: "time asc", //aufsteigend
                },
                {
                    id: 3,
                    name: "Von neu nach alt sortieren",
                    shortName: "date desc", //absteigend
                },
                {
                    id: 4,
                    name: "Von alt nach neu sortieren",
                    shortName: "date asc", //aufsteigend
                },
            ],
        });
        /**
         *  Functions
         */
        function editNote(note) {
            state.selectedNote = cloneData(note);
            state.note = state.selectedNote.text;
        }
        function convertTime(time) {
            var minutes = Math.floor(time / 60);
            var seconds = Math.floor(time % 60);
            var hours = Math.floor(minutes / 60);
            minutes = minutes - hours * 60;
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            if (hours != 0) {
                if (minutes <= 10) {
                    minutes = "0" + minutes;
                }
                return hours + ":" + minutes + ":" + seconds;
            } else {
                return minutes + ":" + seconds;
            }
        }
        async function CREATE_NOTE() {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "add-note-button"
            );
            const response = await store.dispatch(
                `${STORE_TYPES.NOTES}/${NOTE_TYPES.CREATE_NOTE}`,
                {
                    note: {
                        text: state.note,
                        seconds: Math.floor(props.watchTime),
                    },
                }
            );
            if (getData(response, "status") == 201) {
                state.note = "";
            }
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "add-note-button"
            );
        }
        async function UPDATE_NOTE() {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "add-note-button"
            );
            state.selectedNote.text = state.note;
            const response = await store.dispatch(
                `${STORE_TYPES.NOTES}/${NOTE_TYPES.UPDATE_NOTE}`,
                {
                    note: state.selectedNote,
                }
            );
            if (getData(response, "status") == 200) {
                state.note = "";
                state.selectedNote = null;
            }
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "add-note-button"
            );
        }
        async function DELETE_NOTE(note) {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                `delete-note-${note.id}`
            );
            const response = await store.dispatch(
                `${STORE_TYPES.NOTES}/${NOTE_TYPES.DELETE_NOTE}`,
                {
                    note,
                }
            );
            if (getData(response, "status") == 201) {
                state.note = "";
                state.selectedNote = null;
            }
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                `delete-note-${note.id}`
            );
        }
        /**
         *  Computed
         */
        const GET_SLIDE = computed(
            () =>
                store.getters[`${STORE_TYPES.SLIDES}/${SLIDE_TYPES.GET_SLIDE}`]
        );
        const GET_NOTES = computed(
            () => store.getters[`${STORE_TYPES.NOTES}/${NOTE_TYPES.GET_NOTES}`]
        );
        const filterdNotes = computed(() => {
            const allNotes = GET_NOTES.value;

            allNotes.sort(function(noteOne, noteTwo) {
                const filterShortName = getData(
                    state,
                    "selectedFilter.shortName"
                );
                const timeStampA = dateToTimestamp(noteOne.created_at);
                const timeStampB = dateToTimestamp(noteTwo.created_at);
                if (filterShortName == "date desc") {
                    return compareNumbers(timeStampA, timeStampB);
                } else if (filterShortName == "date asc") {
                    return compareNumbers(timeStampB, timeStampA);
                } else if (filterShortName == "time desc") {
                    return compareNumbers(noteOne.seconds, noteTwo.seconds);
                } else if (filterShortName == "time asc") {
                    return compareNumbers(noteTwo.seconds, noteOne.seconds);
                }
            });
            return allNotes;
        });
        const computedTime = computed(() => {
            const watchTime = convertTime(
                state.selectedNote
                    ? state.selectedNote.seconds
                    : props.watchTime
            );

            return watchTime;
        });

        /**
         *  Created
         */
        onMounted(() => {
            state.selectedFilter = state.allFilters[0];
            store.dispatch(
                `${STORE_TYPES.NOTES}/${NOTE_TYPES.FETCH_NOTES}`,
                {}
            );
        });

        return {
            state,
            computedTime,
            CREATE_NOTE,
            UPDATE_NOTE,
            GET_SLIDE,
            GET_NOTES,
            DELETE_NOTE,
            editNote,
            filterdNotes,
        };
    },
});
</script>
